import {
  GET_NOTIFICATIONMANAGER_FAIL,
  GET_NOTIFICATIONMANAGER_SUCCESS,
  GET_NOTIFICATIONMANAGERS_FAIL,
  GET_NOTIFICATIONMANAGERS_SUCCESS,
  ADD_NOTIFICATIONMANAGER_SUCCESS,
  ADD_NOTIFICATIONMANAGER_FAIL,
  UPDATE_NOTIFICATIONMANAGER_SUCCESS,
  UPDATE_NOTIFICATIONMANAGER_FAIL,
  UPDATE_NOTIFICATIONMANAGERSTATUS_SUCCESS,
  UPDATE_NOTIFICATIONMANAGERSTATUS_FAIL,
  DELETE_NOTIFICATIONMANAGER_SUCCESS,
  DELETE_NOTIFICATIONMANAGER_FAIL,  
  SET_STATE_NOTIFICATIONMANAGER
} from "./actionTypes";

const INIT_STATE = {
  notificationManagers: [],
  notificationManager: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const notificationManagers = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONMANAGERS_SUCCESS:
      return {
        ...state,
        notificationManagers: action.payload.notificationManagers,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_NOTIFICATIONMANAGER:
      return { ...state, loading: action.payload }

    case GET_NOTIFICATIONMANAGERS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_NOTIFICATIONMANAGER_SUCCESS:
      return {
        ...state,
        notificationManagers: [...state.notificationManagers, action.payload],
      };

    case ADD_NOTIFICATIONMANAGER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_NOTIFICATIONMANAGER_SUCCESS:
      return {
        ...state,
        notificationManagers: state.notificationManagers.map(notificationManager =>
          notificationManager.id.toString() === action.payload.id.toString()
            ? { ...action.payload, notificationManager }
            : notificationManager
        ),
      };

    case UPDATE_NOTIFICATIONMANAGER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

      case UPDATE_NOTIFICATIONMANAGERSTATUS_SUCCESS:
        return {
          ...state,
          notificationManagers: state.notificationManagers.map(notificationManager =>
            notificationManager.id.toString() === action.payload.id.toString()
              ? { ...action.payload, notificationManager }
              : notificationManager
          ),
        };
  
      case UPDATE_NOTIFICATIONMANAGERSTATUS_FAIL:
        return {
          ...state,
          error: action.payload,
        };

    case DELETE_NOTIFICATIONMANAGER_SUCCESS:
      return {
        ...state,
        notificationManagers: state.notificationManagers.filter(
          notificationManager => notificationManager.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_NOTIFICATIONMANAGER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_NOTIFICATIONMANAGER_SUCCESS:
      return {
        ...state,
        notificationManager: action.payload,
      };

    case GET_NOTIFICATIONMANAGER_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default notificationManagers;
